import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ActionAdd from '../../store/action/Priority/Add'
import ActionEdit from '../../store/action/Priority/Edit'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'priority-id':'',
        'priority-name' : '',
        'sla-hours' : '',
        'sla-days' : '',
         'client-id': '',
          'division-id': '',
          'sender-id':'',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

    componentDidMount(){
        this.props.actionGetAllClient();
        if(this.props.actionType == IsEdit) {
            this.props.actionGetAllDivision( this.props.item.get('client-id'));
            this.props.actionGetAllSender( this.props.item.get('client-id'),  this.props.item.get('division-id'));
        }
    }

  handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value);
      if(field === 'client-id'){
          this.setState({client_id: value})
          this.props.actionGetAllSender(value);
          this.props.actionGetAllDivision(value);

      }

      if (field === 'division-id') {
          let clientId = this.state.client_id;
          if (clientId == null || clientId == "" || clientId == undefined) clientId = this.props.item.get('client-id')
          this.props.actionGetAllSender(clientId, value);
      }
    this.setState({ form:formVal })
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;
    if(form.get('sender-id') == '' || form.get('sender-id') == null || form.get('sender-id') == undefined ) {
        this.setState({error : "Sender cannot be empty!"});
        toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);

        return  false;
    }

    if(form.get('priority-name') === '' || form.get('sla-hours') === '' || form.get('sla-days') === ''){
        this.setState({error : "Name cannot be empty!"});
        toast.error('Priority name, sla hours, sla days cannot be empty!', toast.POSITION.TOP_RIGHT);
    } else{

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code block
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                'priority-name' : form.get('priority-name'),
                'sla-hours'     : form.get('sla-hours'),
                'sla-days'      : form.get('sla-days'),
                'sender-id'     : form.get('sender-id')
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
                'priority-id'   : form.get('priority-id'),
                'priority-name' : form.get('priority-name'),
                'sla-hours'     : form.get('sla-hours'),
                'sla-days'      : form.get('sla-days'),
                'sender-id'     : form.get('sender-id')
          }
        };

        var response = await this.props.actionEdit(data);
      
        if(response.ok){
            data = fromJS(await response.json());
            toast.success(data.get('query-result').get('message'), toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        }else{
            //toast.error(data.get('query-result').get('details'), toast.POSITION.TOP_RIGHT);
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS({
            'priority-id': this.props.item.get('priority-id'),
            'priority-name': this.props.item.get('priority-name'),
            'sla-hours': this.props.item.get('sla-hours'),
            'sla-days': this.props.item.get('sla-days'),
              'client-id' : this.props.item.get('client-id'),
              'division-id': this.props.item.get('division-id'),
              'sender-id': this.props.item.get('sender-id'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
              <span className="col-sm-2">Name</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'priority-name'}
                      value={ form.get('priority-name')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="name"
                      disabled={ disabled }
                      hasError={errors.has('priority-name')}
                  />
              </div>
          </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Client</span>
                <div className="col-sm-10">
                    <ComboboxInput
                        field='client-id'
                        value={form.get('client-id')}
                        options={fromJS({
                            'source': this.props.clientall,
                            'value': 'client-id',
                            'label': 'client-name'
                        }) }
                        onChange={(field, value, label) => this.handleChange(field,value,label)}
                        placeholder="Client"
                    />
                </div>
            </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Divison</span>
                <div className="col-sm-10">
                    <ComboboxInput
                        field='division-id'
                        value={form.get('division-id')}
                        options={fromJS({
                            'source': this.props.divisionall,
                            'value': 'division-id',
                            'label': 'division-name'
                        }) }
                        onChange={(field, value, label) => this.handleChange(field,value,label)}
                        placeholder="Division"
                    />
                </div>
            </div>
            <div className="row no-margin-bottom">
                <span className="col-sm-2">Sender</span>
                <div className="col-sm-10">
                    <ComboboxInput
                        field='sender-id'
                        value={form.get('sender-id')}
                        options={fromJS({
                            'source': this.props.senderall,
                            'value': 'sender-id',
                            'label': 'sender-name'
                        }) }
                        onChange={(field, value, label) => this.handleChange(field,value,label)}
                        placeholder="Sender"
                    />
                </div>
            </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">SLA Hours</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'sla-hours'}
                      value={ form.get('sla-hours')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="sla hours"
                      disabled={ disabled }
                      hasError={errors.has('sla-hours')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">SLA Days</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'sla-days'}
                      value={ form.get('sla-days')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="sla days"
                      disabled={ disabled }
                      hasError={errors.has('sla-days')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
            <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button"
                  className="btn btn-wide btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
        </div>
    );
  }
}


export default connect(
  (state) => {
      return {
          Users: state.user.users,
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
  }, dispatch),
)(Form);